import {inject, Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {LoginInput} from '../domain/user.type';
import {LocalStorageService} from '../../services/local-storage.service';
import {Router} from '@angular/router';

interface LoginResponse {
  token: string;
}

@Injectable({
  providedIn: 'root',
})

export class UsersRepository {
  #http = inject(HttpClient);
  #authUrl = `${ environment.apiUrl }`;
  #localStorage = inject(LocalStorageService);
  checkLogOutSubject: Subject<boolean> = new Subject<boolean>();
  private headers = new HttpHeaders();
  private isToken = false;

  constructor(private readonly router: Router) {
    const token = this.#localStorage.getItem('token');
    if (token) {
      this.isToken = true;
      this.headers = this.headers.set('Authorization', token);
    }
  }

  login$(loginInput: LoginInput): Observable<LoginResponse> {
    return this.#http.post<LoginResponse>(`${ this.#authUrl }/login`, loginInput);
  }

  logout$() {
    this.headers = this.headers.delete('Authorization');
    this.#localStorage.clear();
    this.router.navigate(['login']).then(() => this.checkLogOutSubject.next(true));
  }

  setToken() {
    this.isToken = true;
  }
}
